module.exports = (__webpack_require__(775))(20);